export const UI_TYPES = {
  TOGGLE_DRAWER: 'TOGGLE_DRAWER',
  SET_DASHBAR: 'SET_DASHBAR',
  TOGGLE_TASK: 'TOGGLE_TASK',
  SET_UI: 'SET_UI',
  SET_FILTERS: 'SET_FILTERS',
};
